import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-additional-amount',
  templateUrl: './additional-amount.component.html',
  styleUrls: [],
})
export class AdditionalAmountComponent implements OnInit {
  selectedView: string = 'details';
  summaryData: any;
  pageTitle: string = 'إنشاء خدمة إضافية';
  stepLabel: string = 'تفاصيل الخدمة';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    if(this.route.snapshot.queryParams.additionaInvoice == 'true') {
      this.pageTitle = 'إنشاء معاملة مالية';
      this.stepLabel = 'تفاصيل المعاملة';
    }
  }

  getView(event) {
    this.selectedView = event.viewName;
    this.summaryData = event.data;
  }
}
